import React from 'react';
import { Link } from 'react-router-dom';
import KeyConsultantToggle from './KeyConsultantToggle';
import IconDocumentStatus from "../partials/IconDocumentStatus";

class ConsultantItem extends React.Component {

  render() {


    return (
      <li className="line">
        {this.props.user.role !== "Member" ?
          <div style={{display:"inline-block", width:"auto"}}>
            <KeyConsultantToggle
              id={"list_"+ this.props.consultant._id }
              consultant={this.props.consultant} 
              user={this.props.user}/>
          </div>
          :
          null
        }

        {this.props.consultant.user.active ?
          <Link style={{height:"30px",lineHeight:"30px",display:"inline-block"}} to={"/consultant/"+this.props.consultant._id}>
            <div style={{display:"inline-block", width:"auto",lineHeight:"30px"}}>
              <IconDocumentStatus style={{marginRight:"10px", marginLeft:"10px"}}
              progression={this.props.consultant.progression.globalPercentage}
              validationInformation={this.props.consultant.validationInformation}
              infovisible="false"
              kind="consultant"
              translate = {this.props.translate}
              />
            </div>
            <div style={{display:"inline-block", width:"auto",lineHeight:"30px"}}><i className="fas fa-user-tie" style={{marginRight:"10px", marginLeft:"10px"}}></i></div>
            <div style={{display:"inline-block", width:"auto",lineHeight:"30px"}}><p>{this.props.firstname} {this.props.lastname}</p></div>
          </Link>
          :
          <div style={{cursor:'not-allowed', PointerEvent:'none', display:"inline-block", width:"auto"}} >
            <div style={{display:"inline-block", width:"auto",lineHeight:"30px"}}>
              <IconDocumentStatus style={{marginRight:"10px", marginLeft:"10px"}}
              progression={this.props.consultant.progression.globalPercentage}
              validationInformation={this.props.consultant.validationInformation}
              infovisible="false"
              kind="consultant"
              translate = {this.props.translate}
              />
            </div>
            <div style={{display:"inline-block", width:"auto",lineHeight:"30px"}}><i className="far fa-clock" style={{marginRight:"10px", marginLeft:"10px"}}></i></div>
            <div style={{display:"inline-block", width:"auto",lineHeight:"30px"}}></div><p>{this.props.firstname} {this.props.lastname}</p>
          </div >
        }

        <div className="tools">
          {this.props.projects > 0 ? (
                    <p style={{ width: '100%' }}>{`${this.props.projects} ${this.props.translate(`Page.Project.title`)}`}</p>
          ) : (
            null
          )}
        </div>
      </li>
    );

  }
}


export default ConsultantItem;
